import { Link } from "react-router-dom";

const TickHistoryContentTwo = () => {
  return (
    <div className="how__work__resource">
      <div className="container">
        <div className="row reverse-mobile">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="thumb-left">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/resources/tick_history/tick_history_2.png"
                }
                alt="computer images"
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <h2>Comprehensive Market Insights at Your Commande</h2>
              <p>
                With The Pips Tick History, you gain access to detailed,
                timestamped market data that captures every price change,
                however small. This helps traders evaluate spreads, volatility,
                and liquidity in different market conditions. Whether you’re
                refining your algorithmic models or studying past performance,
                accurate tick data empowers you to optimize trading setups and
                minimize uncertainty. The data is sourced from trusted liquidity
                providers, ensuring reliability and consistency across all
                instruments. By analyzing micro-movements within the market, you
                can uncover patterns and behaviors often missed in standard
                time-based charts. This depth of insight gives you a powerful
                advantage when fine-tuning strategies or validating trading
                hypotheses.
              </p>
              {/* <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Register now
              </Link> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TickHistoryContentTwo;
